export function generateRegex(v: string) {
  const template = v === "" ? /[\w\s]+/ : `^${v}`;
  return new RegExp(template, "i");
}